// src/utils/relicVault/colorUtils.js
//
// Color math used to derive hover / gradient / glow shades from a guild or
// rarity base color. Ported from the designer's handoff (lib/colorUtils.ts).
//
// The gradient helpers return CSS strings; they are only applied on web via
// webOnly() (see ./webStyle). Native falls back to the flat base colors.

const toHex = value => {
  const s = value.toString(16);
  return s.length === 1 ? `0${s}` : s;
};

const channels = hex => {
  const h = hex.replace('#', '');
  return [
    parseInt(h.substring(0, 2), 16),
    parseInt(h.substring(2, 4), 16),
    parseInt(h.substring(4, 6), 16),
  ];
};

/** Darken a hex color by `factor` (0-1, where 1 = original color, 0 = black). */
export function shade(hex, factor) {
  return `#${channels(hex)
    .map(c => toHex(Math.round(c * factor)))
    .join('')}`;
}

/** Lighten a hex color toward white by `factor` (0-1, where 1 = white). */
export function tint(hex, factor) {
  return `#${channels(hex)
    .map(c => toHex(Math.round(c * (1 - factor) + 255 * factor)))
    .join('')}`;
}

/** Soft radial glow used behind relic icons, colored by rarity or guild. */
export function iconGlowFor(color) {
  return `radial-gradient(circle, ${color}55 0%, ${color}22 35%, transparent 65%)`;
}

/** Slightly different glow ratio used specifically behind store relic cards. */
export function relicCardGlow(color) {
  return `radial-gradient(circle, ${color}40, ${color}08 70%)`;
}

/** Every companion card gradient/glow, recomputed from its base guild color. */
export function companionVisuals(color) {
  const dark = shade(color, 0.55);
  const light = tint(color, 0.4);
  return {
    dark,
    light,
    guildGradient: `linear-gradient(135deg, ${color} 0%, ${dark} 100%)`,
    buttonGradient: `linear-gradient(135deg, ${light} 0%, ${color} 100%)`,
    badgeGlow: `radial-gradient(circle, ${color}55 0%, ${dark}CC 100%)`,
    borderGlow: `0 0 0 1px ${color}55, 0 0 26px ${color}38, inset 0 0 30px ${color}12`,
    cardWash: `radial-gradient(ellipse 130% 90% at 74% 10%, ${color}40, transparent 55%), linear-gradient(165deg, ${dark}55 0%, #0A0916 80%)`,
    iconGlow: `radial-gradient(circle, ${color}55, ${color}0A 70%)`,
  };
}
